import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { FiltersComponent } from './filters.component';

@Component({
  selector: 'filter-date',
  templateUrl: './filter-date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDateComponent<Name extends string> {
  constructor(
    private readonly filters: FiltersComponent<{ [K in Name]: string }>,
  ) {}

  @Input()
  name: Name;

  @Input()
  label: string;

  @Input()
  min: string | null = null;

  readonly value = this.filters.value.pipe(
    map(value => value[this.name]),
    distinctUntilChanged(),
  );

  changeValue(value: string) {
    this.filters.changeValue.next({ name: this.name, reduce: () => value });
  }
}
